module.exports = __webpack_public_path__ + "static/media/alert-dark.c1a9ce46.svg";